// posts-slider.js
import Swiper from 'swiper';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    // console.log('Inicjalizacja modułu sliderów postów');

    // Znajdź wszystkie kontenery sliderów postów na stronie
    const postsSliderContainers = document.querySelectorAll('[data-posts-slider-container]');
    // console.log(`Znaleziono ${postsSliderContainers.length} sliderów postów`);

    // Jeśli nie ma żadnego kontenera, zakończ
    if (postsSliderContainers.length === 0) return;

    // Dla każdego kontenera inicjalizuj Swiper z zewnętrznymi przyciskami
    postsSliderContainers.forEach((container) => {
        // Pobierz unikalny identyfikator kontenera
        const containerId = container.getAttribute('data-posts-slider-container');

        // Znajdź elementy wewnątrz tego kontenera
        const slider = container.querySelector('[data-posts-slider-id="' + containerId + '"]');
        const pagination = container.querySelector('[data-posts-slider-pagination="' + containerId + '"]');
        const prevButton = container.querySelector('[data-posts-slider-prev="' + containerId + '"]');
        const nextButton = container.querySelector('[data-posts-slider-next="' + containerId + '"]');

        // Sprawdź, czy slider istnieje
        if (!slider) {
            console.warn(`Posts slider element with data-posts-slider-id="${containerId}" not found`);
            return;
        }

        // Inicjalizacja Swipera dla tego kontenera
        const swiperInstance = new Swiper(slider, {
            // Załaduj moduły
            modules: [Pagination, Navigation, Autoplay],

            // Podstawowe ustawienia
            slidesPerView: 2.3,  // Domyślnie pokazuje 1 slajd
            spaceBetween: 15,  // Odstęp między slajdami


            // Autoplay (opcjonalnie)
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            // Opcje paginacji (jeśli element istnieje)
            pagination: pagination ? {
                el: pagination, 
                clickable: true,
            } : false,

            // Przyciski nawigacji (jeśli elementy istniej ą)
            navigation: (nextButton && prevButton) ? {
                nextEl: nextButton,
                prevEl: prevButton,
            } : false,

            // Ustawienia responsywne zgodnie z wymaganiami
            breakpoints: {
                // >= 768px
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                // >= 968px
                968: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                // >= 1024px
                1024: {
                    slidesPerView: 2.8,
                    spaceBetween: 30,
                },
                // >= 1200px
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                // >= 1300px
                1300: {
                    slidesPerView: 3.33,
                    spaceBetween: 30,
                },
                1600: {
                    slidesPerView: 4.33,
                    spaceBetween: 30,
                },
                1900: {
                    slidesPerView: 5.33,
                    spaceBetween: 30,
                },
            }
        });
    });
});